import {useQuery} from "@tanstack/react-query";
import {qk} from "@queries/keys";
import WalletService from "@lib/Wallet/WalletService";

export function useMainWallet() {
    return useQuery({
        queryKey: qk.wallet(),
        queryFn: () => WalletService.getBalance(),
        staleTime: 10 * 60_000,
        retry: 1,
    });
}
